<template>

  <ControlloNoteCredito />
 
</template>

<script>
import ControlloNoteCredito from '../components/pratiche/ControlloNoteCredito.vue'

export default {
  components: {
    ControlloNoteCredito

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

